import { useEffect, useState } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import Error from '@/assets/featureko.svg';
import { WaitProcessModal } from '@/components/Elements/WaitProcessModal';
import { createPaymentMethod } from '@/features/payment';
import { getAllAxiosData, GetterAxios } from '@/lib/axios';
import { getMyRateURL } from '@/utils/helpers';

//https://payments.dev.mdirector.com/account/update-payment-method

export const UpdatePaymentMethodPage = () => {
  const { t } = useTranslation();
  const handleError = useErrorHandler();
  const [url, setUrl] = useState<string | null>(null);

  const renderWaitProcessModal = (url: string | null) => {
    let title = t('UpdatePaymentMethodPage.title');
    let description = t('UpdatePaymentMethodPage.description');
    let timeInMS = 2000;
    let customImage = undefined;

    if (url === 'error') {
      title = t('UpdatePaymentMethodPage.titleError');
      description = t('UpdatePaymentMethodPage.descriptionError');
      timeInMS = 7000;
      url = getMyRateURL();
      customImage = Error;
    }

    const wait = () => {};
    return (
      <WaitProcessModal
        timeInMS={timeInMS}
        title={title}
        description={description}
        customImage={customImage}
        isOpen={true}
        timeoutCallback={() => {
          return url ? window.location.assign(url) : wait;
        }}
      />
    );
  };

  useEffect(() => {
    const getters: GetterAxios[] = [{ callback: createPaymentMethod, parameters: {} }];
    const setters: any = [setUrl];
    const pageData = getAllAxiosData(getters, setters);
    pageData
      .then((response) => {
        if (response?.type === 'error') {
          setUrl(response?.type);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  }, [handleError]);

  return renderWaitProcessModal(url);
};
